import { EletricBolt } from 'src/components/Icons/EletricBolt'
import { InView } from 'react-intersection-observer'
import { useGlobalContext } from 'src/components/contexts/GlobalContext'

import { FreightDetailsPrice } from './FreightDetailsPrice'
import { sendShippingEvent } from '../utils/sendShippingEvent'

interface Props {
  shippingEstimate: string
  value: number
}

export function NextDayDelivery({ shippingEstimate, value }: Props) {
  const { pageData } = useGlobalContext()

  return (
    <InView
      as="div"
      triggerOnce
      onChange={(inView) => {
        if (inView) {
          sendShippingEvent({ eventName: 'frete nextday', pageData })
        }
      }}
      className="flex items-start justify-between w-full"
    >
      <div className="flex flex-col gap-[2px]">
        <div className="flex items-center justify-start">
          <p className="text-black text-sm leading-[21px] font-semibold mr-1">
            Receba amanhã
          </p>
          <EletricBolt width={14} height={14} />
        </div>
        <p className="text-restructure-primary text-sm leading-[21px] font-regular">
          Comprando em até{' '}
          <span className="text-expressText inline-block">
            {shippingEstimate}
          </span>
        </p>
      </div>
      <FreightDetailsPrice deliveryValue={value} />
    </InView>
  )
}
